import { requestForLost } from "api/Appointment";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";

export const useLostFeedback = (onConfirm: () => void) => {
  const queryClient = useQueryClient();
  return useMutation(requestForLost, {
    onSuccess: () => {
      queryClient.invalidateQueries("appointments");
      queryClient.invalidateQueries(['widgetData', 'Upcoming Appointments'])
      toast.success("Lost feedback sent successfully");
      onConfirm();
    },
    onError: () => {
      toast.error(`Something went wrong`);
    },
  });
};
